import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { updateOrder } from "./liveOrder.store";

const SOUND_KEY = "mealinkr_sound_enabled";

export default function Toasts() {
  const [queue, setQueue] = useState([]);

  // 🔑 restore from localStorage
  const [soundEnabled, setSoundEnabled] = useState(
    () => localStorage.getItem(SOUND_KEY) === "true"
  );

  const audioRef = useRef(null);
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  /* ----------------------------------------
     INIT AUDIO
  ---------------------------------------- */
  useEffect(() => {
    audioRef.current = new Audio(
      `${process.env.PUBLIC_URL}/sounds/mixkit-bell-notification-933.wav`
    );
    audioRef.current.volume = 0.6;
    audioRef.current.preload = "auto";
  }, []);

  /* ----------------------------------------
     ENABLE SOUND (CLICK ONCE)
  ---------------------------------------- */
  const enableSound = useCallback(async () => {
    try {
      await audioRef.current.play();
      audioRef.current.pause();
      audioRef.current.currentTime = 0;

      localStorage.setItem(SOUND_KEY, "true"); // 💾 save
      setSoundEnabled(true);
    } catch (err) {
      console.error("Sound unlock failed", err);
    }
  }, []);

  /* ----------------------------------------
     START SOUND LOOP
  ---------------------------------------- */
  const startSound = useCallback(() => {
    if (!soundEnabled || intervalRef.current) return;
    if (!audioRef.current) return;

    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => {});

    intervalRef.current = setInterval(() => {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }, 3000);
  }, [soundEnabled]);

  /* ----------------------------------------
     STOP SOUND
  ---------------------------------------- */
  const stopSound = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }, []);

  /* ----------------------------------------
     WEBSOCKET LISTENER
  ---------------------------------------- */
  useEffect(() => {
    const onNewOrder = (e) => {
      const order = e.detail;
      if (!order) return;

      setQueue((q) =>
        q.some((o) => String(o.id) === String(order.id))
          ? q
          : [order, ...q]
      );

      startSound();
    };

    window.addEventListener("mlk:new_order", onNewOrder);
    return () =>
      window.removeEventListener("mlk:new_order", onNewOrder);
  }, [startSound]);

  /* ----------------------------------------
     CLICK TOAST = STOP SOUND
  ---------------------------------------- */
  const onToastClick = useCallback(
    (id) => {
      stopSound();
      updateOrder(id, { status: "pending" });
      setQueue((q) =>
        q.filter((o) => String(o.id) !== String(id))
      );
      navigate("/live-orders");
    },
    [stopSound, navigate]
  );

  /* ----------------------------------------
     RENDER
  ---------------------------------------- */
  return (
    <>
      {/* 🔔 SHOW ONLY IF NEVER ENABLED */}
      {!soundEnabled && (
        <div className="sound-gate">
          <button
            className="lo-btn-enable-sound"
            onClick={enableSound}
          >
            🔔 Enable Order Sound
          </button>
        </div>
      )}

      {queue.length > 0 && (
        <div className="lo-toasts-wrap">
          {queue.map((o) => (
            <div
              key={o.id}
              className="lo-toast"
              onClick={() => onToastClick(o.id)}
            >
              <div className="lo-toast-head">
                <strong>New Order #{o.id}</strong>
              </div>

              {/* <div className="lo-toast-body">
                <div>{o.customer?.name ?? "Customer"}</div>
                <div>
                  {o.currency === "INR" ? "₹" : ""}
                  {o.total}
                </div>
              </div> */}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
